import { Button } from "@fluentui/react-components";
import { DocumentTableRegular } from "@fluentui/react-icons";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAppStoreState } from "store/AppStore";
import { usePaymentPlanPageStore } from "store/PaymentPlanPageStore";
import { ExportExcelHandle } from "../ExportExcel";

type Props = {
  refExcelExport: ExportExcelHandle | undefined;
};

export const ExportExcelButton = ({ refExcelExport }: Props) => {
  const { t } = useTranslation();
  const [
    { xlsRowItems, paymentPlansLoadStatus },
    { loadPaymentPlansForReport, setPaymentPlanStoreValue },
  ] = usePaymentPlanPageStore();
  const { updatedGrecoCompanies } = useAppStoreState();

  // The report rows are loaded on click and land in the store; the file is
  // written once they are there. save() itself ignores an empty row set.
  useEffect(() => {
    if (xlsRowItems && xlsRowItems.length > 0) {
      refExcelExport?.save();
    }
  }, [xlsRowItems]);

  return (
    <Button
      data-help="payment-plans-export-excel"
      appearance="subtle"
      icon={<DocumentTableRegular fontSize={24} />}
      disabled={paymentPlansLoadStatus === "loading"}
      onClick={() => {
        loadPaymentPlansForReport({
          updatedGrecoCompanies,
          onSuccess: (res) => {
            setPaymentPlanStoreValue("xlsRowItems", res);
          },
          onError: () => {},
        });
      }}
    >
      {t("greco.exportExcel")}
    </Button>
  );
};
